import {AbstractControl, ValidationErrors, ValidatorFn} from '@angular/forms'
import {
  DOWN_PAYMENT_MINIMUM_PERCENT,
  DOWN_PAYMENT_MINIMUM_PERCENTAGE
} from '@sparbanken-syd/loan-backend'

export const LOAN_MINIMUM = 200 * 1000

export const loanPropertyPriceValidator: ValidatorFn = (control: AbstractControl): ValidationErrors | null => {
  const price = control.get('price')
  const downPayment = control.get('downPayment')
  if (!price || !downPayment || !price.value || !downPayment.value) {
    return null
  }

  price.setErrors(null)
  downPayment.setErrors(null)

  if (downPayment.value / price.value < DOWN_PAYMENT_MINIMUM_PERCENTAGE) {
    downPayment.setErrors({
      error: `Kontantinsatsen måste vara minst ${DOWN_PAYMENT_MINIMUM_PERCENT}% ` +
        `(${Math.ceil(price.value * DOWN_PAYMENT_MINIMUM_PERCENTAGE)
          .toLocaleString('sv-SE')})`
    })
    return {
      downPayment: 'foo'
    }
  }
  if (price.value - downPayment.value < LOAN_MINIMUM) {
    price.setErrors({
      error: `Lånebelopp måste vara minst ${LOAN_MINIMUM
        .toLocaleString('sv-SE')} kr`
    })
    return {
      price: `Lånebelopp måste vara minst ${LOAN_MINIMUM.toLocaleString('sv-SE')} kr`
    }
  }
  return null
}
